import { forwardRef, useEffect, useRef } from 'react'
import { ModalProps, ModalType } from './types'
import { Dialog, CloseButton, Header } from './components'

import * as S from './styles'

const ModalComponent = forwardRef<HTMLDivElement, ModalProps>(
  (
    {
      id,
      children,
      className = '',
      showCloseIcon = false,
      onClose,
      show = false,
      htmlBodyScrollable = true,
      closeOnClickOutside = true,
      hasHeader = false,
      maxWidth,
      ...rest
    },
    ref
  ) => {
    const localRef = useRef(null)
    const parentRef = ref
    const dialogRef = parentRef ? parentRef : localRef

    const handleClickClose = () => {
      if (onClose) onClose()
    }

    useEffect(() => {
      if (!htmlBodyScrollable && show) {
        document.body.style.overflow = 'hidden' // Remove scroll from body when mount

        return () => {
          document.body.style.overflow = 'auto' // Add scroll to body when unmount
        }
      }
    }, [htmlBodyScrollable, show])

    if (!show) return null

    return (
      <S.Overlay id={id}>
        <Dialog
          className={className}
          ref={dialogRef}
          onClose={closeOnClickOutside ? onClose : undefined}
          hasHeader={hasHeader}
          maxWidth={maxWidth}
          {...rest}
        >
          <>
            {showCloseIcon && <CloseButton onClose={handleClickClose} />}
            {children}
          </>
        </Dialog>
      </S.Overlay>
    )
  }
)

ModalComponent.displayName = 'Modal'

const Modal: ModalType = ModalComponent as ModalType
Modal.Header = Header

export default Modal
